import type { WebRtcLifecycleState } from './types';

export type WebRtcStateCause =
  | 'start'
  | 'negotiation'
  | 'peer-connecting'
  | 'peer-connected'
  | 'peer-disconnected'
  | 'peer-failed'
  | 'close';

export function nextWebRtcState(
  current: WebRtcLifecycleState,
  cause: WebRtcStateCause,
): WebRtcLifecycleState {
  if (current === 'closed') {
    return 'closed';
  }

  switch (cause) {
    case 'start':
      return current === 'idle' ? 'starting' : current;
    case 'negotiation':
      return current === 'connected' ? 'connected' : 'negotiating';
    case 'peer-connecting':
      return 'connecting';
    case 'peer-connected':
      return 'connected';
    case 'peer-disconnected':
      return 'disconnected';
    case 'peer-failed':
      return 'failed';
    case 'close':
      return 'closed';
  }
}
